<template></template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  mounted() {
    this.getList();
    this.getLenguage();
  },
  methods: {
    ...mapActions("language", ["getList", "getLenguage"]),
  },
  computed: {
    ...mapState("language", ["lang","translations"]),
  },
};
</script>
